export default function (element, data) {   
    window.addEventListener("scroll", update, {
        passive: true,
    });

    window.addEventListener("resize", update, {
        passive: true,
    });

    window.addEventListener("load", update);

    const threshold = data.threshold;
    const classBelow = data.classBelow;
    const classAbove = data.classAbove;
    
    function update() {
        const scroll = window.scrollY;
        const currentState = scroll > threshold ? "below" : "above";

        if (scroll > threshold) {
            if (classBelow) {
                element.classList.add(classBelow);
            }
            
            if (classAbove) {
                element.classList.remove(classAbove);
            }
        } else {
            if (classAbove) {
                element.classList.add(classAbove);
            }
        
            if (classBelow) {
                element.classList.remove(classBelow);
            }
        }
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary